import Image from '@base/Image';
import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';

const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 150px;
  gap: ${Spacings.SPACING_4B};
  align-items: center;
  justify-content: center;
`;

const ImageWrapper = styled.div`
  height: ${Spacings.SPACING_10B};
  width: ${Spacings.SPACING_10B};
  position: relative;
`;

const InfoWrapper = styled(Typography)`
  width: 211px;
  color: var(--color-i-gray-13);
`;

const EmptyHallOfFameList = () => {
  return (
    <EmptyWrapper>
      <ImageWrapper>
        <Image src="referrals/emptyReferral.svg" alt="laptop" layout="fill" />
      </ImageWrapper>
      <InfoWrapper variant="p2">
        Referral Hall of Fame will be published on 2nd of every month
      </InfoWrapper>
    </EmptyWrapper>
  );
};

export default EmptyHallOfFameList;
